import UserDataGrid from './UserDataGrid';

export default UserDataGrid;
